import { type TOC } from '@ember/component/template-only';
import UiCheckboxWithBlock, {
  type Signature as UiCheckboxWithBlockComponentSignature
} from './ui-checkbox-with-block.gts';

export interface Signature {
  Element: UiCheckboxWithBlockComponentSignature['Element'];
  Args: UiCheckboxWithBlockComponentSignature['Args'];
}

const CheckboxComponent: TOC<Signature> = <template>
  <UiCheckboxWithBlock
    @checked={{@checked}}
    @onChange={{@onChange}}
    @disabled={{@disabled}}
    @isReadOnly={{@isReadOnly}}
    @labelName={{@labelName}}
    @payloadKey={{@payloadKey}}
    @isMandatory={{@isMandatory}}
    @dataTestInput={{@dataTestInput}}
    ...attributes
  />
</template>;
export default CheckboxComponent;
